









import { Component, Vue, Prop } from 'vue-property-decorator'
import LatestPoliciesService from '@/api/policies/LatestPoliciesService'
import { TermsCondition } from '@/shared/models/TermsCondition'
import store from '@/store/store'
import PageHeaderComponent from '../PageHeaderComponent.vue'

@Component({
  components: {
    PageHeaderComponent
  }
})
export default class TermsAndConditionsComponent extends Vue {
  private response?: TermsCondition = {};

  public async beforeCreate () {
    this.response = await LatestPoliciesService.GetTermsAndConditions()
    store.saveToSVersion(this.response)
  }
}
